import React, { useEffect, useState } from 'react';
import { productsAPI } from '../utils/api';
import ProductCard from '../components/ProductCard';
import SEO, { SITE_URL } from '../components/SEO';

const Sale = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      const { data } = await productsAPI.getAll({});
      const saleProducts = data.filter(p => p.discount_price && p.discount_price < p.price);
      setProducts(saleProducts);
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="sale-page">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-cormorant text-4xl sm:text-5xl lg:text-6xl leading-none mb-8" data-testid="sale-heading">Sale</h1>
        <SEO title="Sale - Discounts on Premium Ethnic Wear" description="Exclusive discounts on premium ethnic wear at Studio Crochet. Shop sarees, lehengas, Pakistani suits on sale. COD available." canonical={`${SITE_URL}/sale`} />
        <p className="font-outfit text-lg text-[#8C8577] mb-12">Exclusive discounts on premium ethnic wear</p>
        
        {loading ? (
          <div className="text-center py-20" data-testid="loading-indicator">
            <p className="font-outfit text-[#8C8577]">Loading...</p>
          </div>
        ) : products.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-12" data-testid="products-grid">
            {products.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20" data-testid="no-products">
            <p className="font-outfit text-[#8C8577]">No sale items available at the moment</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sale;